/**
 * Transformers API Mappers
 *
 * Maps between frontend camelCase and backend API format
 */

interface UpdateTransformerInfoRequest {
  name: string;
  config: string;
  tag: string;
  version: number;
  baseId: string;
  id: number;
  description: string;
  languageVersion: string;
  processingType: string;
  maxDataProcTime: string;
}

interface UpdateTransformerInfoApiPayload {
  name: string;
  config: string;
  environ: string; // tag -> environ
  version: number;
  baseid: string; // baseId -> baseid (UUID string)
  id: number;
  description: string;
  languageVersion: string;
  processingType: string;
  maxDataProcTime: string;
}

/**
 * Map frontend transformer update request to API payload
 */
export const toUpdateTransformerInfoPayload = (
  data: UpdateTransformerInfoRequest
): UpdateTransformerInfoApiPayload => {
  return {
    name: data.name,
    config: data.config,
    environ: data.tag, // Frontend uses "tag", API expects "environ"
    version: data.version, // Number
    baseid: data.baseId, // Frontend uses "baseId", API expects lowercase "baseid" (number)
    id: data.id, // Number
    description: data.description,
    languageVersion: data.languageVersion,
    processingType: data.processingType,
    maxDataProcTime: data.maxDataProcTime,
  };
};
